// ===========================================================================
// Charge Capture (Módulo N) — prototipo final sobre el modelo de CASOS.
// docs/modulos/ChargeCapture/CONCEPCION_PROTOTIPO_CHARGE_CAPTURE.md.
// Capa de servicio fake con contrato real hasta que exista el backend.
//
// Dos superficies:
//   /charge-capture          → biller (Inventario · Cola · Resultados)
//   /charge-capture/queries  → médico (una consulta a la vez, tres botones)
// ===========================================================================
import React, { lazy } from "react";
import { CHARGE_CAPTURE_BASE_PATH } from "./common/constants";

const ChargeCapturePage = lazy(() => import("./pages/ChargeCapturePage"));
const PhysicianQueriesPage = lazy(() => import("./pages/PhysicianQueriesPage"));

export const chargeCaptureRoutes = [
  { path: CHARGE_CAPTURE_BASE_PATH, element: <ChargeCapturePage /> },
  { path: `${CHARGE_CAPTURE_BASE_PATH}/queries`, element: <PhysicianQueriesPage /> },
];

export { CHARGE_CAPTURE_BASE_PATH } from "./common/constants";
export default ChargeCapturePage;
